function setHeightForGapAside(element, gapBody, gapAside, gap) {
    let height = gapBody.getBoundingClientRect().height;
    let gapHeight = gap.getBoundingClientRect().height;

    // If window is on mobile set aside 60% of content in gap
    if (window.outerWidth <= 960) {
        let imageHeight = gap.getBoundingClientRect().height / 100;
        gapAside.style.top = imageHeight * 20 + 'px';
        gapAside.style.height = imageHeight * 60 + 'px';
        return false;
    }

    if (height < gapHeight) {
        gapAside.style.top = (gapHeight - height) / 2 + 'px';
    } else {
        gapAside.style.top = -(height - gapHeight) / 2 + 'px';
    }
    gapAside.style.height = gapBody.getBoundingClientRect().height + 'px';

}

$elements = document.getElementsByClassName('gap');
if ($elements.length) {
    for (let i = 0; i < $elements.length; i++) {
        let element = $elements[i];
        let gapBody = element.querySelector('.gap__content-body');
        let gap = element.querySelector('.gap__body');
        let gapAside = element.querySelector('.gap__aside');

        setHeightForGapAside(element, gapBody, gapAside, gap);
        window.addEventListener('resize', () => setHeightForGapAside(element, gapBody, gapAside, gap));
        window.addEventListener('load', () => setHeightForGapAside(element, gapBody, gapAside, gap));
    }
}
